import { PencilIcon } from 'lucide-react'
import { useState } from 'react'

import PartnersTeamMemberPanel from 'components/partners/PartnersTeamMemberPanel'
import type { PartnersPartnerAdmin } from 'utils/web_api.schemas'
import { useWindowLocation } from 'utils/windowLocation'

interface AdminPartnerAdminRolesProps {
  partnerAdmin: PartnersPartnerAdmin
  partnerId: string
}

export default function AdminPartnerAdminRoles ({ partnerAdmin, partnerId }: AdminPartnerAdminRolesProps) {
  const [isPanelOpen, setIsPanelOpen] = useState(false)
  const [currentRoles, setCurrentRoles] = useState(partnerAdmin.roles)
  const [currentTeamMember, setCurrentTeamMember] = useState(partnerAdmin)
  const { reload } = useWindowLocation()

  const handleOpenPanel = () => {
    setIsPanelOpen(true)
  }

  const handleClosePanel = () => {
    setIsPanelOpen(false)
  }

  const handleUpdate = (newRoles: string[]) => {
    setCurrentRoles(newRoles)
    setCurrentTeamMember({ ...currentTeamMember, roles: newRoles })
  }

  const handleRemove = () => {
    reload()
  }

  return (
    <>
      <button
        type='button'
        onClick={handleOpenPanel}
        className='inline-flex items-center text-left gap-1 text-indigo-600 hover:text-indigo-900 hover:underline cursor-pointer'
      >
        {currentRoles.join(', ')}
        <PencilIcon className='h-3 w-3' />
      </button>

      <PartnersTeamMemberPanel
        teamMember={currentTeamMember}
        isOpen={isPanelOpen}
        onClose={handleClosePanel}
        onUpdate={handleUpdate}
        onRemove={handleRemove}
        partnerId={partnerId}
      />
    </>
  )
}
